import { CacheableDataObject } from 'models/CacheableDataObject.jsx';
import UserChatRoom from 'components/UserChatRoom';
import { DateFormat } from './DateFormat';

export class UserChatRooms extends CacheableDataObject {

	beforeConstruct() {
		this.chat_rooms = {};
	}

	updateChatRoomData(chatRooms) {
		_.each(chatRooms, (chatRoom, index) => {
			let oldData = null;
			if(chatRoom.id) {
				oldData = this.chat_rooms[chatRoom.id];
			}
			else {
				oldData = this.chat_rooms[index];
			}

			if(oldData) {
				oldData.update(chatRoom);
			}
			else {
				const newUserChatRoom = UserChatRoom.create(chatRoom);
				if(chatRoom.id) {
					this.chat_rooms[chatRoom.id] = newUserChatRoom;
				}
				else {
					newUserChatRoom.id = index;
					this.chat_rooms[index] = newUserChatRoom;
				}
			}
		});
	}

	addChatRoomData(chatRoom) {
		this.updateChatRoomData([chatRoom]);
	}

	isModOrAdmin(chatRoomId) {
		return this.isMod(chatRoomId) || this.isAdmin(chatRoomId);
	}

	retrieve(chatRoomId) {
		if(this.chat_rooms[chatRoomId]) {
			return this.chat_rooms[chatRoomId];
		}
		else {
			return this.chat_rooms[chatRoomId] = UserChatRoom.create();
		}
	}

	isMod(chatRoomId) {
		return this.chat_rooms[chatRoomId] && this.chat_rooms[chatRoomId].isMod();
	}

	getMain(chatRoomId) {
		return this.chat_rooms[chatRoomId] ? this.chat_rooms[chatRoomId].getMain() : null;
	}

	/** The main for the given room, else the first known room's main (for DMs, which have no game). */
	getAnyMain(preferredChatRoomId) {
		const preferredMain = this.getMain(preferredChatRoomId);
		if(preferredMain) {
			return preferredMain;
		}
		const roomWithMain = Object.values(this.chat_rooms).find((userChatRoom) => userChatRoom.getMain());
		return roomWithMain ? roomWithMain.getMain() : null;
	}

	/** When the room's searching flag last arrived (ms), 0 if never. */
	searchingReportedAt(chatRoomId) {
		const chatRoom = this.chat_rooms[chatRoomId];
		return (chatRoom && chatRoom.searchingReportedAt) || 0;
	}

	isSearching(chatRoomId) {
		return !!this.chat_rooms[chatRoomId] && this.chat_rooms[chatRoomId].isSearching();
	}

	isAdmin(chatRoomId) {
		return this.chat_rooms[chatRoomId] && this.chat_rooms[chatRoomId].isAdmin();
	}

}